import SocketIO from 'socket.io-client'
import {
 SOCKET_CREATED,
 SOCKET_CONNECTED,
 SOCKET_DISCONNECTED,
 BLOCKS_MINED_ADD,
 RETRIEVING_DATA
} from '../actions/types';

import {getBalances} from '../actions/passport/get'
import genAllWallet from '../actions/passport/generate/all';

import {getSpendableOutpoints} from '../actions/passport/get/nrg'
import {getAllTransfers} from '../actions/transfers/get'
import {getOpenOrders, getMatchedOrders,getUnmatchedOrders} from '../actions/orderbook/get';
import {matchOrders} from '../actions/orderbook/matchingEngine';
import callBC from '../actions/helpers/bc';
import {collateralizeFilter,filterHistoricalOrders,calculateStats} from '../actions/orderbook/filter';
process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';

export const init = (location, dispatch, store) => {
  let url = location.port != '' ? `wss://${location.hostname}:${location.port}` : `wss://${location.hostname}`;
  const socket = SocketIO(url, {path: '/ws',rejectUnauthorized: false,transports:['websocket']});

  dispatch({type:SOCKET_CREATED,payload:{socket,location}})

  setInterval( async ()=> {
    if(!store.getState().socket.connected) {
      let data = await callBC(store.getState().settings.settings,'getLatestBlock',[])
      getAllTransfers(dispatch,store.getState)
      getBalances(dispatch,store.getState())
      if(data.result && data.result.height) {
        updateOrdersState(data.result,dispatch,store)
      }
    }
  }, 10000)

  socket.on('connect', () => {
    dispatch({type: SOCKET_CONNECTED,payload:socket})

    socket.on('disconnect', ()=> dispatch({type: SOCKET_DISCONNECTED}))

    //get latest block when we start up
    socket.emit('block.get',{id:'latest'});

    const events = ['block.set','block.mined','block.new']
    events.forEach((event) => {
      socket.on(event, async (data) => {
        if(data) updateOrdersState(data,dispatch,store)
      })
    })
  });
}

//on each new block, get balances and orders
const updateOrdersState = async (data,dispatch,store) => {
  if(data)dispatch({type:BLOCKS_MINED_ADD,payload:data});
  if(store.getState().socket.retrieving == false ||
  store.getState().ui_marketplace.loading == true
){
    dispatch({type:RETRIEVING_DATA,payload:true})
    await getBalances(dispatch,store.getState())
    await getOpenOrders(dispatch,store.getState())
    await collateralizeFilter(dispatch,store.getState())
    matchOrders(dispatch,store.getState)
    await getAllTransfers(dispatch,store.getState)
    await getMatchedOrders(false,dispatch,store.getState())
    getUnmatchedOrders(dispatch,store.getState())
    getSpendableOutpoints(dispatch,store.getState())
    // calculateStats(dispatch,store.getState())
    dispatch({type:RETRIEVING_DATA,payload:false})
  }
}

const initialState = {
 latestBlock: null,
 location: {},
 timestamp: 0,
 bcHeight: "SYNCING",
 retrieving: false,
 connected: false,
 socket: null
}

export const reducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case BLOCKS_MINED_ADD:
      return { ...state, bcHeight: action.payload.height,timestamp:action.payload.timestamp,latestBlock:action.payload};

    case SOCKET_CREATED:
      // console.log(action.payload);
      return { ...state, socket:action.payload.socket,location:action.payload.location}

    case SOCKET_CONNECTED:
      console.log('socket connected')
      return { ...state, connected: true}

    case SOCKET_DISCONNECTED:
      console.log('socket disconnected')
      return { ...state, connected: false,socket:state.socket }

    case RETRIEVING_DATA:
      return { ...state, retrieving: action.payload}

    default:
      return state
  }
}
